import React, { useRef, useState } from "react";
import { shallowEqual } from "react-redux";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { useBnbSelector } from "../../../redux/store";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as Text from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import type { BuildAndBuyLabelType } from "../../../utils/labels";
import { BnbLabel } from "../../../utils/labels";
import { formatPrice } from "../../../../../../common-deprecated/Globalize";
import useWinterWheelsModal from "../../../hooks/customize/winterwheels/useWinterWheelsModal";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import type { WinterWheelCategoryType } from "../../../../../../common-deprecated/constants";
import { STUDDED } from "../../../../../../common-deprecated/constants";
import {
    calculateWinterWheelPrice,
    GetColourForEULabel,
    getCorrectWinterWheelCategoryLabel,
    tyreInfoBnbLabelSelector,
} from "../../../utils/typedUtils";
import Price from "../common/price/Price";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as Input from "../../../../../../common-deprecated/styles/v2/lexus/components/Input";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Styles from "../step-customize/car-hero/styles/WinterWheels";
import type { WinterWheelsModalType } from "../../../utils/modalConstants";
import { EcoBadge } from "../../../../../../common-deprecated/styles/v2/lexus/components/EcoLabel";
import Popover from "../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import type { ModalViewType, WinterWheelType } from "../../../../../../common-deprecated/types/CommonTypes";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import ImageFluid from "../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import * as TabStyles from "../common/styles/Tabs";
import * as WinterWheelsModalStyles from "./styles/WinterWheelsModalStyles";
import { theme } from "../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonSecondary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { getCarDBAssetSrcSet } from "../../../../../shared-logic/utils/imageUtils";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { useDispatch } from "../../../../../../shared-logic/redux/store";
import { MODAL_DETAILED_TYRE_INFO } from "../../../../../../shared-logic/utils/tyreInfoContants";

type WinterWheelsCategoryPropsType = {
    wheelType: WinterWheelCategoryType;
    winterWheels: WinterWheelType[];
    selectedWinterWheel: WinterWheelType | null;
    modalTransitionComplete: boolean;
    selectWinterWheel: (winterWheel: WinterWheelType) => void;
};

const WinterWheelsCategory = (props: WinterWheelsCategoryPropsType): JSX.Element => {
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const tyreInfoLabels = useBnbSelector(tyreInfoBnbLabelSelector, shallowEqual);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const { wheelType, winterWheels, selectedWinterWheel, selectWinterWheel } = props;

    return (
        <Styles.CardRow>
            {winterWheels
                .filter((wheel) => wheel.wheelCategory === wheelType)
                .map((wheel) => (
                    // WinterWheelCard

                    <Styles.Card width={{ xs: 1, sm: 1 / 2, lg: 1 / 3 }} key={wheel.id}>
                        <Flex.Row>
                            <Flex.Col width={{ _: 1 }} display="flex" justifyContent="center">
                                <ImageFluid
                                    {...getCarDBAssetSrcSet(commonSettings, [{ width: 450, height: 450 }], wheel.image)}
                                    width="180"
                                    height="180"
                                    sizes="180px"
                                    loading="lazy"
                                    alt={`${wheel.name}`}
                                />
                            </Flex.Col>
                        </Flex.Row>

                        {wheel.wheelCategory !== STUDDED && wheel.euLabelProperties && (
                            <Flex.Row>
                                <Styles.WheelEULabelProps>
                                    <IconWrapper>
                                        <Icon variant="gas" />
                                    </IconWrapper>
                                    <EcoBadge
                                        backgroundColor={GetColourForEULabel(wheel.euLabelProperties.fuelEfficiency)}
                                    >
                                        {wheel.euLabelProperties.fuelEfficiency}
                                    </EcoBadge>
                                    <IconWrapper>
                                        <Icon variant="cloudRain" />
                                    </IconWrapper>
                                    <EcoBadge backgroundColor={GetColourForEULabel(wheel.euLabelProperties.wetGrip)}>
                                        {wheel.euLabelProperties.wetGrip}
                                    </EcoBadge>
                                    <IconWrapper>
                                        <Icon variant="sound" />
                                    </IconWrapper>
                                    <EcoBadge backgroundColor={GetColourForEULabel(wheel.euLabelProperties.noise)}>
                                        {wheel.euLabelProperties.noise}
                                    </EcoBadge>
                                </Styles.WheelEULabelProps>
                            </Flex.Row>
                        )}

                        <Styles.CategoryName>
                            {wheel.name}
                            {wheel.description && <Popover showOnClick content={wheel.description} />}
                        </Styles.CategoryName>
                        <Price price={wheel.price} financeItemId={wheel.id} />
                        <Styles.CategoryDescription>
                            <div>
                                <BnbLabel label="winterWheelsModalTyreSize" />
                                {wheel.setProperties}
                            </div>
                            <div>
                                <BnbLabel label="winterWheelsModalPartNumber" />
                                {wheel.setPartNumber}
                            </div>
                        </Styles.CategoryDescription>
                        {wheel.tyre && !!tyreInfoLabels && (
                            <Flex.Row>
                                <Flex.Col display="flex">
                                    <Button.Link
                                        color="grey7"
                                        hasIconRight
                                        onClick={(event) => {
                                            event.preventDefault();
                                            if (wheel.tyre) {
                                                dispatch(
                                                    showModal({
                                                        type: MODAL_DETAILED_TYRE_INFO,
                                                        tyres: [wheel.tyre],
                                                        tyreInfoLabels,
                                                    }),
                                                );
                                            }
                                        }}
                                    >
                                        <Text.Button>
                                            <BnbLabel label="tyreInfo" />
                                        </Text.Button>
                                        <IconWrapper>
                                            <Icon variant="info" />
                                        </IconWrapper>
                                    </Button.Link>
                                </Flex.Col>
                            </Flex.Row>
                        )}
                        <Styles.WheelButtonContainer>
                            <Button.Checkbox
                                type="button"
                                onClick={() => selectWinterWheel(wheel)}
                                selected={!!selectedWinterWheel && selectedWinterWheel.id === wheel.id}
                            >
                                <IconWrapper>
                                    <Icon
                                        variant={
                                            selectedWinterWheel && selectedWinterWheel.id === wheel.id
                                                ? "close"
                                                : "plus"
                                        }
                                    />
                                </IconWrapper>
                            </Button.Checkbox>
                        </Styles.WheelButtonContainer>
                    </Styles.Card>
                ))}
        </Styles.CardRow>
    );
};

const WinterWheelsModal = (props: ModalViewType<WinterWheelsModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const settings = useBnbSelector((state) => state.commonSettings);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const [modalTransitionComplete, setModalTransitionComplete] = useState(false);
    const footerRef = useRef<HTMLDivElement>(null);

    const wheelData = useWinterWheelsModal(close, footerRef, 5, { padding: 0 });
    const { previewImage, cheapestWinterWheel, hasMultipleWheelTypes, wheelType, selectWheelType, wheelCategories } =
        wheelData;
    const { winterWheels, selectedWinterWheel, selectWinterWheel } = wheelData;
    const { includeInstallation, updateInstallationState, totalPrice, confirm, cancel } = wheelData;

    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={cancel}
            show={show}
            size="lg"
            onTransitionEnd={() => setModalTransitionComplete(true)}
        >
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="winterWheelsModalTitle" />
                </Modal.Title>
                <Modal.Button onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Styles.Header>
                    <Flex.Row>
                        <Flex.Col width={{ _: 1, sm: 6 / 12, md: 5 / 12 }} order={{ xs: 2, sm: 1 }}>
                            <WinterWheelsModalStyles.Description>
                                <BnbLabel label="winterWheelsModalDescription" />
                            </WinterWheelsModalStyles.Description>
                            {showPrice(settings) &&
                                (cheapestWinterWheel.price.cash > 0 || cheapestWinterWheel.price.monthly > 0) && (
                                    <Type.Strong>
                                        <Price
                                            price={calculateWinterWheelPrice(cheapestWinterWheel)}
                                            financeItemId={cheapestWinterWheel.id}
                                        />
                                    </Type.Strong>
                                )}
                        </Flex.Col>
                        <Flex.Col width={{ _: 1, sm: 6 / 12, md: 7 / 12 }} order={{ xs: 1, sm: 2 }}>
                            <ImageFluid alt={previewImage.alt} src={previewImage.src} />
                        </Flex.Col>
                    </Flex.Row>
                </Styles.Header>
                <Styles.Content>
                    {/* Category Tabs */}
                    {hasMultipleWheelTypes && (
                        <Flex.Row mb={5}>
                            <Flex.Col width={1}>
                                <TabStyles.Wrapper>
                                    {wheelCategories.map((category) => (
                                        <TabStyles.Tab
                                            key={category}
                                            px="0"
                                            isActive={wheelType === category}
                                            onClick={() => selectWheelType(category)}
                                        >
                                            <BnbLabel label={getCorrectWinterWheelCategoryLabel(category)} />
                                        </TabStyles.Tab>
                                    ))}
                                </TabStyles.Wrapper>
                            </Flex.Col>
                        </Flex.Row>
                    )}

                    <WinterWheelsCategory
                        winterWheels={winterWheels}
                        selectWinterWheel={selectWinterWheel}
                        wheelType={wheelType}
                        selectedWinterWheel={selectedWinterWheel}
                        modalTransitionComplete={modalTransitionComplete}
                    />

                    {/* WinterWheelEuLabelLegend */}
                    {wheelType !== STUDDED && (
                        <Styles.Legend>
                            <Icon variant="gas" />
                            <Type.SmallText>
                                <BnbLabel label="winterWheelsEuLabelFuelEfficiency" />
                            </Type.SmallText>
                            <Icon variant="cloudRain" />
                            <Type.SmallText>
                                <BnbLabel label="winterWheelsEuLabelWetGrip" />
                            </Type.SmallText>
                            <Icon variant="sound" />
                            <Type.SmallText>
                                <BnbLabel label="winterWheelsEuLabelNoise" />
                            </Type.SmallText>
                        </Styles.Legend>
                    )}
                    {/* WinterWheelInstallation */}
                    <Type.H4 mb={1} mt={5}>
                        <BnbLabel label="winterWheelsModalInstallationTitle" />
                    </Type.H4>

                    <Styles.ModalInstallationDescription>
                        <BnbLabel label="winterWheelsModalInstallationDescription" />
                    </Styles.ModalInstallationDescription>

                    <form>
                        <Input.Wrapper variant="radio">
                            <input
                                type="radio"
                                checked={includeInstallation}
                                id="winterWheelInstallationYes"
                                onChange={() => updateInstallationState(true)}
                            />
                            <Input.Checkbox htmlFor="winterWheelInstallationYes" isDark hasSmallText>
                                <BnbLabel
                                    label={
                                        `winterWheelsModalInstallationYesText${
                                            selectedWinterWheel.installationCost ? "WithPrice" : ""
                                        }` as BuildAndBuyLabelType
                                    }
                                    params={{
                                        cost:
                                            selectedWinterWheel.installationCost &&
                                            selectedWinterWheel.installationCost.cash
                                                ? formatPrice(
                                                      selectedWinterWheel.installationCost.cash,
                                                      settings.culture.name,
                                                  )
                                                : "",
                                    }}
                                />
                            </Input.Checkbox>
                        </Input.Wrapper>
                        <Input.Wrapper variant="radio">
                            <input
                                type="radio"
                                checked={!includeInstallation}
                                id="winterWheelInstallationNo"
                                onChange={() => updateInstallationState(false)}
                            />
                            <Input.Checkbox htmlFor="winterWheelInstallationNo" isDark hasSmallText>
                                <BnbLabel label="winterWheelsModalInstallationNoText" />
                            </Input.Checkbox>
                        </Input.Wrapper>
                    </form>

                    <Type.Text as="p" mt={3} color={theme.colors.grey3}>
                        <BnbLabel label="winterWheelsModalInstallationTyreHotel" />
                    </Type.Text>

                    {/* WinterWheelsTotalPrice */}
                    <Flex.Row justifyContent="space-between" mt={5}>
                        <Flex.Col>
                            <Type.H4 mb={1}>
                                <BnbLabel label="winterWheelsModalTotalWinterSetPriceTitle" />
                            </Type.H4>
                            {includeInstallation && !selectedWinterWheel.installationCost && (
                                <Type.SmallText color={theme.colors.grey3}>
                                    <BnbLabel label="winterWheelsModalExcludingInstallationCosts" />
                                </Type.SmallText>
                            )}
                            {includeInstallation && selectedWinterWheel.installationCost && (
                                <Type.SmallText color={theme.colors.grey3}>
                                    <BnbLabel label="winterWheelsModalIncludingInstallationCosts" />
                                </Type.SmallText>
                            )}
                        </Flex.Col>
                        <Flex.Col textAlign="right">
                            <Type.H4 mb={1}>
                                <Price price={totalPrice} financeInfo={financeInfo} />
                            </Type.H4>
                        </Flex.Col>
                    </Flex.Row>
                </Styles.Content>
                <Styles.Footer>
                    {/* Button Footer */}
                    <Flex.Row ref={footerRef} justifyContent="center">
                        <Flex.Col
                            width={{ xs: 1, sm: 6 / 12, lg: 5 / 12 }}
                            mb={{ xs: 3, sm: 0 }}
                            order={{ xs: 1, sm: 2 }}
                        >
                            <ButtonPrimary onClick={confirm} fullWidth>
                                <BnbLabel label="winterWheelsModalConfirmSetButton" />
                            </ButtonPrimary>
                        </Flex.Col>
                        <Flex.Col width={{ xs: 1, sm: 6 / 12, lg: 5 / 12 }} order={{ xs: 2, sm: 1 }}>
                            <ButtonSecondary onClick={cancel} fullWidth>
                                <BnbLabel label="winterWheelsModalCancelSetButton" />
                            </ButtonSecondary>
                        </Flex.Col>
                    </Flex.Row>
                </Styles.Footer>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default WinterWheelsModal;
